import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { SplunkRum } from '@splunk/otel-web';
import { SamplingDecision } from '@opentelemetry/sdk-trace-base';

var CustomSampler = /*#__PURE__*/function () {
  function CustomSampler(_ref) {
    var debug = _ref.debug,
        sampleRatio = _ref.sampleRatio,
        recordAll = _ref.recordAll;

    _classCallCheck(this, CustomSampler);

    _defineProperty(this, "recordAll", void 0);

    _defineProperty(this, "sampler", void 0);

    this.recordAll = recordAll !== null && recordAll !== void 0 ? recordAll : false;
    this.sampler = debug ? new SplunkRum.AlwaysOnSampler() : new SplunkRum.SessionBasedSampler({
      ratio: sampleRatio
    });
  }

  _createClass(CustomSampler, [{
    key: "shouldSample",
    value: function shouldSample(context, traceId, spanName, spanKind, attributes, links) {
      var baseSampleResult = this.sampler.shouldSample(context, traceId, spanName, spanKind, attributes, links); // If the base sampler decides to record and sample, or we don't want to record, return the base result

      if (baseSampleResult.decision === SamplingDecision.RECORD_AND_SAMPLED || !this.recordAll) {
        return baseSampleResult;
      } // Override sampling decision, we want to record all spans, but only sample a subset of them


      return _objectSpread(_objectSpread({}, baseSampleResult), {}, {
        decision: SamplingDecision.RECORD
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'CustomSampler';
    }
  }]);

  return CustomSampler;
}();

export default CustomSampler;